import type { Dispatch } from '@reduxjs/toolkit';
import type { ICommonState } from 'src/legacy/@types/common';

import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/legacy/utils/axios';

// ----------------------------------------------------------------------

const initialState: ICommonState = {
  error: null,
  isLoading: false,
  languages: [],
  states: [],
};

const slice = createSlice({
  initialState,
  name: 'common',
  reducers: {
    // GET LANGUAGES
    getLanguagesSuccess(state, action) {
      state.isLoading = false;
      state.languages = action.payload;
    },

    // GET CITIES
    getStatesSuccess(state, action) {
      state.isLoading = false;
      state.states = action.payload;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { getLanguagesSuccess } = slice.actions;

// ----------------------------------------------------------------------

export const getNativeLanguages = () => {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/core/native-languages');
      dispatch(slice.actions.getLanguagesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
};

// ----------------------------------------------------------------------

export const getStates = () => {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/core/states');
      dispatch(slice.actions.getStatesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
};
